@value container from '../activity-types/activity-type-defaults.module.css';

.horizontal-field-container {
    composes: container;
    grid-template-columns: 104px 1fr;
    padding: 0;
    align-items: center;
}

.horizontal-field-container label {
    margin-bottom: 0;
}
